import mitt from 'mitt';

export default mitt();


// WEBPACK FOOTER //
// ./src/utils/mitt.js